var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHashStrong(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15.998,
    viewBox: "0 0 16 15.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_26792",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 26792",
    d: "M1672.085,11532.9a8,8,0,1,0,8,8A8,8,0,0,0,1672.085,11532.9Zm.943,8,2.2,2.2a.667.667,0,1,1-.943.943l-2.2-2.2-2.2,2.2a.667.667,0,0,1-.942-.943l2.2-2.2-2.2-2.2a.666.666,0,0,1,.942-.941c.1.1,2.2,2.2,2.2,2.2l2.2-2.2a.666.666,0,0,1,.943.941C1675.121,11538.8,1673.028,11540.9,1673.028,11540.9Z",
    transform: "translate(-1664.085 -11532.898)",
    fill: "#b7c0c8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashStrong);
export default __webpack_public_path__ + "static/media/hash-strong.721aa2c1425d3e83c00020a7e866f92e.svg";
export { ForwardRef as ReactComponent };